<template>
    <v-row>
        <v-col cols="12" sm="6" offset-sm="3">
            <v-card class="elevation-12">
                <v-toolbar class='grey darken-3' dark>
                    <v-toolbar-title>Login</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-form @submit.prevent="login">
                    <v-card-text>
                        <v-text-field prepend-icon="person" name="username" v-model="username" label="Email Address" type="text" autocomplete="username"></v-text-field>
                        <v-text-field prepend-icon="lock" name="password" v-model="password" label="Password" id="password" autocomplete="current-password" type="password"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="orange darken-4" dark type="submit">Login</v-btn>
                    </v-card-actions>
                </v-form>
                <v-card-text id="forgot"><a href='#signup'>Forgot your Password?</a></v-card-text>
            </v-card>
            <div id="signup">Don't have an account?  <v-btn class="orange darken-4" dark to="/signup">Sign Up!</v-btn></div>
            <div></div>
        </v-col>
    </v-row>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Login',
        data () {
            return {
                username: "",
                password: "",
                after: "/"

            }
        },
        computed: {
            ...mapState(['currentUser'])
        },
        methods: {
            login: function () {
                let username = this.username;
                let password = this.password;
                var query = (this.$route.query && this.$route.query.redirect) || this.after;
                // var _this = this;
                console.log('logging in', username, query);
                // if (query) query = { path: query };
                // var goNext = (function () { console.log('goNext', _this.$router, query); _this.$router.push(query); });
                this.$store.dispatch("login", { username, password })
                    .then( location.reload() )
                    .catch(err => console.log(err));
                // this.$router.push('/signup');
                
            }
        }
    };
    
</script>

<style>
.elevation-12 {
    margin-top: 3rem;
}
#forgot {
    text-align: right;
}
#signup {
    margin-top: 3rem;
    text-align: center;
    font-weight: bold;
}
</style>
